import styled from "styled-components";

export const StyledProfile = styled.div`
  display: flex;

  & img {
    max-width: 136px;
    max-height: 136px;
    border-radius: 16px;
    margin-right: 40px;
  }
`

export const FormContent = styled.div`
  width: 100%;
`
export const StyledProfileHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`
